<div class="side-panel ui-scrollbar">
    <ng-container *permissions="'PSDImport'">
        <size-add-tabs (selectedTabChange)="selectTab($event)">
            <div tab1>
                <ng-container *ngTemplateOutlet="sizesContentTemplate"></ng-container>
            </div>
            <div tab2>
                <ng-container *ngTemplateOutlet="psdContentTemplate"></ng-container>
            </div>
        </size-add-tabs>
    </ng-container>

    <ng-container *permissions="'!PSDImport'">
        <ng-container *ngTemplateOutlet="sizesContentTemplate"></ng-container>
    </ng-container>
</div>

<ng-template #sizesContentTemplate>
    <size-add-custom-input (customSizeAdded)="addCustomSize($event)"></size-add-custom-input>
    <size-add-overview
        label="Sizes selected"
        [currentSelected]="addedSizes().length"
        (toggleAll)="toggleAllSizes()">
    </size-add-overview>
    <div
        id="size-list"
        class="size-lists">
        <ng-container *ngFor="let sizeCategory of sizeCategories()">
            <size-list
                *ngIf="sizeCategory.sizes.length > 0"
                [label]="sizeCategory.label"
                [type]="sizeCategory.type"
                [stickyHeight]="sizeCategory.stickyHeight"
                [sizes]="sizeCategory.sizes"
                (sizeSelected)="selectSize($event)"
                (sizesChanged)="selectedSizes($event, sizeCategory)">
            </size-list>
        </ng-container>
    </div>
</ng-template>

<ng-template #psdContentTemplate>
    <psd-list *ngIf="selectedTab === Tabs.PSD_IMPORT"></psd-list>
</ng-template>

<size-add-preview
    *ngIf="selectedTab === Tabs.SIZE_ADD"
    [sizes]="addedSizes()"
    (onCancel)="close()">
</size-add-preview>

<psd-import-preview
    *ngIf="selectedTab === Tabs.PSD_IMPORT"
    (onCancel)="close()">
</psd-import-preview>
